import React from 'react';
import AccountView from './MonProfil.view';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/reducers';
import { QueryUserAccountQuery } from '../../graphql/generated/graphql';
import { ApolloError, useQuery } from '@apollo/client';
import { QUERY_USER_ACCOUNT } from '../../graphql/query/user/queryUserAccount';
import { matchPath, useLocation, useParams } from 'react-router-dom';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import pages from '../../routes/pages';
import { getUserStateFromQueryAccount } from '../../helpers/transformApiResponse/user';

const Account = () => {
  const userId = useSelector((state: AppState) => state.user.id);
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();

  const isOnUserEditPage =
    matchPath(location.pathname, {
      path: pages.ELEVE_ACCOUNT_PAGE.path,
      exact: true
    }) && true;

  const { data, loading, error } = useQuery<QueryUserAccountQuery>(
    QUERY_USER_ACCOUNT,
    {
      variables: { id: isOnUserEditPage ? id : userId }
    }
  );

  if (loading) return <LoadingLayout />;
  if (error) return <ErrorContainer detailErr={new ApolloError(error)} />;

  return (
    <AccountView user={getUserStateFromQueryAccount(data.getUserAccount)} />
  );
};

export default Account;
